<template>

  <div v-if="item.children" :key="item.text">
    <v-list-group :prepend-icon="item.icon">
      <template v-slot:activator>
        <v-list-item-content class="textsize-svs">
          <v-list-item-title>
            {{ $t(item.text) }}
          </v-list-item-title>
        </v-list-item-content>
      </template>

      <template v-for="(child, i) in item.children">
        <v-list-item v-if="hasAccess(child)" :key="i" :to="child.route">
          <v-list-item-action v-if="child.icon" class="ml-4">
            <v-icon v-if="!child.isCustomIcon">{{ child.icon }}</v-icon>
            <div v-if="child.isCustomIcon" v-html="child.icon"/>
          </v-list-item-action>
          <v-list-item-content class="textsize-svs">
            <v-list-item-title>
              {{ $t(child.text) }}
            </v-list-item-title>
          </v-list-item-content>
      </v-list-item>
      </template>
    </v-list-group>

  </div>
  <div v-else :key="item.text">

    <v-list-item :to="item.route">
      <v-list-item-action>
        <v-icon v-if="!item.isCustomIcon">{{ item.icon }}</v-icon>
        <div v-if="item.isCustomIcon" v-html="item.icon"/>
      </v-list-item-action>
      <v-list-item-content class="textsize-svs">
        <v-list-item-title>
          {{ $t(item.text) }}
        </v-list-item-title>
      </v-list-item-content>

    </v-list-item>
    <v-divider v-if="item.divider"></v-divider>
  </div>

</template>

<script>
import * as Security from '@/core/security'

export default {
  props: ['item'],
  methods: {
    hasAccess (item) {
      return Security.hasAccess(item.claims)
    }
  }
}
</script>
